import { useEffect, useState } from 'react'

/**
 * IS THIS A PHONE, as the stylesheet counts one.
 *
 * The workspace has a sidebar on a desk and a bar under the thumb on a phone,
 * and both were being RENDERED at every width, with CSS hiding whichever one
 * did not apply. That is fine for pixels and wrong for everything else: two
 * navigation landmarks with the same label, two buttons called Jobs, and a
 * keyboard or a screen reader walking through four destinations that are not
 * on the screen.
 *
 * ONE BREAKPOINT, IN ONE PLACE, matching styles/workspace.css exactly. If that
 * number ever moves it moves here too, and there is a test that fails the day
 * the two disagree - because the failure mode is silent: a phone would render
 * a sidebar the stylesheet has already hidden, and the app would have no
 * navigation at all.
 */
export const PHONE = '(max-width: 860px)'

export function useIsPhone(): boolean {
  const [is, setIs] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia ? false : window.matchMedia(PHONE).matches,
  )
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const q = window.matchMedia(PHONE)
    const on = () => setIs(q.matches)
    // Read once on mount as well: a tablet rotated between the first render
    // and this effect would otherwise keep the wrong navigation.
    on()
    q.addEventListener('change', on)
    return () => q.removeEventListener('change', on)
  }, [])
  return is
}
